import { render } from "./EditTariffView.vue?vue&type=template&id=403dbcba"
import script from "./EditTariffView.vue?vue&type=script&lang=js"
export * from "./EditTariffView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__